import { FC, useState } from 'react';
import styled from 'styled-components';

import SearchInput from 'dashboard/components-lib/SearchInput';
import { TimelineViewMode } from 'dashboard/views/DashboardWorkflowRunsShowView/WorkflowRunTimeline';
import Select, { Option } from 'design-system/components/Select';
import { HStack } from 'design-system/components/Stack';

const StyledSearchInput = styled(SearchInput)`
  flex-grow: 1;
`;

const StyledSelect = styled(Select)`
  width: 200px;
`;

interface TimelineInputsProps {
  enableSetTimelineViewMode: boolean;
  onSearch: (value: string) => void;
  onSetTimelineViewMode(viewMode: TimelineViewMode): void;
}

export const TimelineInputs: FC<TimelineInputsProps> = ({
  enableSetTimelineViewMode,
  onSearch,
  onSetTimelineViewMode,
}) => {
  const [viewMode, setViewMode] = useState<TimelineViewMode>('fit');

  return (
    <HStack>
      <StyledSearchInput
        title={null}
        handleInput={onSearch}
        value=''
        placeholder='Find step name'
      />
      <StyledSelect
        disabled={!enableSetTimelineViewMode}
        value={viewMode}
        onValueChange={(mode: TimelineViewMode) => {
          onSetTimelineViewMode(mode);
          setViewMode(mode);
        }}
      >
        <Option key='fit' value='fit'>
          Fit chart to view
        </Option>
        <Option key='expand' value='expand'>
          Expand chart fully
        </Option>
      </StyledSelect>
    </HStack>
  );
};
